// extracted by mini-css-extract-plugin
export var root = "Section-module--root--3zjbr";